module.exports = "https://wrf-static.prod-my.games/promo/long-lp/img/twitch.1253fe8d.svg";